<script setup lang="ts">
/**
 * 404. Ловит и неизвестные адреса, и удалённые сущности: ключи задач ходят по
 * почте и чатам, и ссылка на удалённую задачу переживает саму задачу.
 */
import { AppButton } from '@vinprop/design-system'
import { FileQuestion } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import TrackerEmptyState from '@/components/TrackerEmptyState.vue'

const { t } = useI18n()
const router = useRouter()
</script>

<template>
  <TrackerEmptyState
    :icon="FileQuestion"
    :title="t('errors.notFound.title')"
    :description="t('errors.notFound.description')"
  >
    <AppButton variant="primary" @click="router.push('/my')">{{ t('errors.back') }}</AppButton>
  </TrackerEmptyState>
</template>
